'use strict';

var AppState = require('app_state');
var AbstractFormView = require('components/common/views/abstract_form_view');
var i18n = require('utils/i18n');
var Requests = require('utils/requests');

var SignupView = AbstractFormView.extend({
    template: require('components/account/templates/signup'),

    controller: undefined,

    events: {
        'click button.js-signup': 'signupClicked',
        'click span.js-lang': 'languageClicked',
        'click a#js-terms': 'termsClicked',
        'click a#js-gdpr': 'gdprClicked',
        'click a#js-imprint': 'imprintClicked',
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.fixedEmail = options.email;
        this.refActivation = options.refActivation;

        AbstractFormView.prototype.initialize.apply(this, [
            {
                inputFields: {
                    'js-username': {},
                    'js-email': {
                        method: 'email',
                    },
                    'js-password': {
                        decoIcon: 'glyphicon glyphicon-ok',
                        method: 'password',
                    },
                    'js-register-terms': {
                        event: 'click',
                        method: 'checkbox',
                    },
                    'js-register-gdpr': {
                        event: 'click',
                        method: 'checkbox',
                    },
                },
                errors: options.errors,
                formData: options.formData,
            },
        ]);
    },

    serializeData: function () {
        var data = AbstractFormView.prototype.serializeData.apply(this, arguments);

        data.lang = i18n.language.toUpperCase();
        data.isSubdomain = AppState.isSubdomain;
        data.fixedEmail = this.fixedEmail;

        return data;
    },

    signupClicked: function (e) {
        e.preventDefault();
        if (this.allFieldsValid()) {
            this.controller.signup(Backbone.Syphon.serialize(this), this.refActivation);
        }
    },

    languageClicked: function (e) {
        i18n.languageClicked(e);
    },

    termsClicked: function (e) {
        e.preventDefault();
        this.controller.showTermsDialog(true);
    },

    gdprClicked: function (e) {
        e.preventDefault();
        this.controller.showGdprDialog(true);
    },

    imprintClicked: function (e) {
        e.preventDefault();
        this.controller.showImprint();
    },

    onAttach: function () {
        $('[data-toggle="popover"]').popover();

        var subdomain = Requests.getSubdomain(window.location.host) || 'samson';
        $('.account-pages').css('background-image', 'url(../img/backgrounds/' + subdomain + '.jpg)');
    },
});

module.exports = SignupView;
